import { LOCALE_TYPE } from 'src/types/locale';
import { getLocaleFromUrl } from 'src/utils/subdomain';

const openZendesk = () => {
  if (getLocaleFromUrl() === LOCALE_TYPE.CN) return;
  window.zE('messenger', 'open');
};

const closeZendesk = () => {
  if (getLocaleFromUrl() === LOCALE_TYPE.CN) return;
  window.zE('messenger', 'close');
};

export { closeZendesk, openZendesk };
